import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import HomeView from '../views/HomeView.vue'
import AdminView from '@/views/AdminView.vue'
import AppointmentView from '@/views/AppointmentView.vue'
import CheckinView from '@/views/CheckinView.vue'
import CoachView from '@/views/CoachView.vue'
import CoachMembersView from '@/views/CoachMembersView.vue'
import CoachCoursesView from '@/views/CoachCoursesView.vue'
import CourseView from '@/views/CourseView.vue'
import EquipmentView from '@/views/EquipmentView.vue'
import EquipmentDetailView from '@/views/EquipmentDetailView.vue'
import LoginView from '@/views/LoginView.vue'
import MemberView from '@/views/MemberView.vue'
import MemberProfileView from '@/views/MemberProfileView.vue'
import MemberCoursesView from '@/views/MemberCoursesView.vue'
import MemberCoachesView from '@/views/MemberCoachesView.vue'
import MemberEquipmentView from '@/views/MemberEquipmentView.vue'
import CoachProfileView from '@/views/CoachProfileView.vue'
import AboutView from '@/views/AboutView.vue'


// meta.roles 表示可访问该路由的角色，为空表示所有已登录用户均可访问
const routes = [
  { path: '/login', name: 'login', component: LoginView, meta: { requiresAuth: false } },
  { path: '/', name: 'home', component: HomeView, meta: { requiresAuth: true } },
  { path: '/member', name: 'member', component: MemberView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/coach', name: 'coach', component: CoachView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/course', name: 'course', component: CourseView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/coach-members', name: 'coachMembers', component: CoachMembersView, meta: { requiresAuth: true, roles: ['coach'] } },
  { path: '/coach-courses', name: 'coachCourses', component: CoachCoursesView, meta: { requiresAuth: true, roles: ['coach'] } },
  { path: '/appointment', name: 'appointment', component: AppointmentView, meta: { requiresAuth: true, roles: ['admin', 'coach', 'member'] } },
  { path: '/equipment', name: 'equipment', component: EquipmentView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/equipment/:id', name: 'equipmentDetail', component: EquipmentDetailView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/checkin', name: 'checkin', component: CheckinView, meta: { requiresAuth: true, roles: ['admin', 'coach', 'member'] } },
  { path: '/profile', name: 'profile', component: MemberProfileView, meta: { requiresAuth: true, roles: ['member'] } },
  { path: '/member-courses', name: 'memberCourses', component: MemberCoursesView, meta: { requiresAuth: true, roles: ['member'] } },
  { path: '/member-coaches', name: 'memberCoaches', component: MemberCoachesView, meta: { requiresAuth: true, roles: ['member'] } },
  { path: '/member-equipment', name: 'memberEquipment', component: MemberEquipmentView, meta: { requiresAuth: true, roles: ['member'] } },
  { path: '/coach-profile', name: 'coachProfile', component: CoachProfileView, meta: { requiresAuth: true, roles: ['coach'] } },
  { path: '/admin', name: 'admin', component: AdminView, meta: { requiresAuth: true, roles: ['admin'] } },
  { path: '/about', name: 'about', component: AboutView, meta: { requiresAuth: false } },


  // 未匹配路由重定向到首页
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  const userRole = store.getters.userRole

  // 不需要登录的路由直接放行
  if (to.meta.requiresAuth === false) {
    // 已登录时访问登录页，自动跳转到首页
    if (to.path === '/login' && isLoggedIn) {
      return next('/')
    }
    return next()
  }

  // 需要登录但未登录，跳转到登录页
  if (!isLoggedIn) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // 已登录，检查角色权限
  const allowedRoles = to.meta.roles
  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    // 无权限：跳转到首页
    return next('/')
  }

  next()
})

export default router
